import React from 'react';
import './AboutThankYou.css';

const AboutThankYou = () => {
    return (
        <section className="thank-you-section">
            <div className="thank-you-container">
                <div className="thank-you-content">
                    <h2 className="section-title">Thank You for Choosing Prints Carts</h2>
                    <p>
                        We appreciate your trust in us. Whether you are shopping for home, school, or office needs,
                        our goal is to support you with a dependable and enjoyable shopping experience—every step of the way.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutThankYou;
